import squareDotSmPattern from '../styles/patterns/1_SQUARE_DOT_48px.svg'
import bigDotPattern from '../styles/patterns/2_BIG_DOT.svg'
import linesPattern from '../styles/patterns/3_LINES.svg'
import rectanglesPattern from '../styles/patterns/5_RECTANGLES.svg'
import horizontalLinesPattern from '../styles/patterns/6_HORIZONTAL_LINES.svg'
import squaresPattern from '../styles/patterns/7_SQUARES.svg'
import diagonalPattern from '../styles/patterns/8_diagonal_222222_60.svg'
import plusPattern from '../styles/patterns/8_plus_222222_60.svg'
import trianglesPattern from '../styles/patterns/8_TRIANGLES.svg'
import circlesPattern from '../styles/patterns/10_CIRCLES.svg'
import dotPattern from '../styles/patterns/12_dot_222222_60.svg'

export const PATTERNS = [
  {
    id: 'diagonal',
    svg: diagonalPattern,
  },
  {
    id: 'plus',
    svg: plusPattern,
  },
  {
    id: 'dot',
    svg: dotPattern,
  },
  {
    id: 'square-dot-sm',
    svg: squareDotSmPattern,
  },
  {
    id: 'big-dot',
    svg: bigDotPattern,
  },
  {
    id: 'lines',
    svg: linesPattern,
  },
  {
    id: 'rectangles',
    svg: rectanglesPattern,
  },
  {
    id: 'horizontal-lines',
    svg: horizontalLinesPattern,
  },
  {
    id: 'squares',
    svg: squaresPattern,
  },
  {
    id: 'triangles',
    svg: trianglesPattern,
  },
  {
    id: 'circles',
    svg: circlesPattern,
  },
]

export function getPatternByIndex(index) {
  const wrappedIndex = index % PATTERNS.length
  return PATTERNS[wrappedIndex]
}
